"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRevertedStatus = exports.orderByResourceTemplate = exports.uniqueDiscountTemplate = exports.UNIQUE_SPLIT_CHAR = exports.uniqueTaxTemplate = exports.installmentStatusDict = exports.REVERTED_STATUSES = exports.MIN_ACH_PAYMENT_AMOUNT = void 0;
const payment_enums_1 = require("../enums/payment.enums");
exports.MIN_ACH_PAYMENT_AMOUNT = 0.5;
exports.REVERTED_STATUSES = [
    payment_enums_1.PaymentStatusEnum.REFUNDED,
    payment_enums_1.PaymentStatusEnum.VOID,
    payment_enums_1.PaymentStatusEnum.DISCOUNT,
    payment_enums_1.PaymentStatusEnum.REVERT_DISCOUNT,
];
exports.installmentStatusDict = {
    [payment_enums_1.FuturePaymentStatusEnum.SUCCEEDED]: 1,
    [payment_enums_1.FuturePaymentStatusEnum.PENDING]: 2,
    [payment_enums_1.FuturePaymentStatusEnum.FUTURE]: 3,
    [payment_enums_1.FuturePaymentStatusEnum.CANCELED]: 4,
    [payment_enums_1.FuturePaymentStatusEnum.FAILED]: 6,
    null: 5,
    default: 6,
};
const uniqueTaxTemplate = (lineItem) => {
    return `${lineItem.taxPrecent}_${lineItem.isTaxInclusive}`;
};
exports.uniqueTaxTemplate = uniqueTaxTemplate;
exports.UNIQUE_SPLIT_CHAR = '&';
const uniqueDiscountTemplate = (discountItem) => {
    var _a, _b;
    const discountPercentage = (_a = `${discountItem.discountPercentage}`) !== null && _a !== void 0 ? _a : '';
    return `${discountItem.actionId}_${discountItem.discountId}_${(_b = discountItem.discount) === null || _b === void 0 ? void 0 : _b.type}_${discountPercentage}`;
};
exports.uniqueDiscountTemplate = uniqueDiscountTemplate;
const orderByResourceTemplate = (resource, type) => {
    var _a, _b, _c;
    return `${(_b = (_a = resource[`${type}`]) === null || _a === void 0 ? void 0 : _a.startDate) !== null && _b !== void 0 ? _b : ''}_${(_c = resource[`${type}`]) === null || _c === void 0 ? void 0 : _c.id}`;
};
exports.orderByResourceTemplate = orderByResourceTemplate;
const isRevertedStatus = (paymentStatus) => {
    return exports.REVERTED_STATUSES.includes(paymentStatus);
};
exports.isRevertedStatus = isRevertedStatus;
//# sourceMappingURL=payment.consts.js.map